import React from "react";

export const navigationRef: any = React.createRef();
export const routeNameRef: any = React.createRef();
export const isReadyRef: any = React.createRef();
